<script lang="ts">
import type { WithClassAsProps } from '@convatec/ui/app/types'
import type { PrimitiveProps } from 'reka-ui'
import type { ContainerUiSlots, ContainerUiVariants } from './config'
import { useForwardProps } from 'reka-ui'
import { container } from './config'

export interface ContainerProps extends PrimitiveProps, WithClassAsProps {
  variant?: ContainerUiVariants['variant']
  fullWidth?: boolean
  noPadding?: boolean
  hasGaps?: boolean
  ui?: ContainerUiSlots
}
</script>

<script setup lang="ts">
defineOptions({ name: 'UiContainer' })

const props = withDefaults(defineProps<ContainerProps>(), {
  as: 'div',
  variant: 'content',
  fullWidth: false,
  noPadding: false,
  hasGaps: false,
})

const rootProps = useForwardProps(reactivePick(props, 'as', 'asChild'))

const ui = computed(() => container({
  variant: props.variant,
  fullWidth: props.fullWidth,
  noPadding: props.noPadding,
  hasGaps: props.hasGaps,
}))
</script>

<template>
  <RekaPrimitive
    v-bind="rootProps"
    :class="ui.root({ class: [props.class, props.ui?.root] })"
  >
    <slot />
  </RekaPrimitive>
</template>
